<template>
  <div class="define-table-wrap">
    <c-table
      :data="tableData"
      :props="config.props"
      :header="tableColumn"
      class="defineTable"
      :class="[
        config.props.isSpaced?'isSpaced':''
      ]"
    ></c-table>
  </div>
</template>

<script>
export default {
  name: 'DefineTable',
  props: {
    config: {
      type: Object,
      default () {
        return {}
      }
    },
    chartData: {
      type: [Array, Object],
      default () {
        return []
      }
    }
  },
  computed: {
    tableData () {
      // let temp = JSON.parse(JSON.stringify(this.chartData))
      // let count = this.config.tableData.count || 3
      // return temp.splice(0, count)
      let temp = JSON.parse(JSON.stringify(this.chartData))
      let count = this.config.tableData.count || 2
      let tempColum = this.config.tableColumn

      let list = temp.splice(0, count)
      // return temp.splice(0, count).map(item => {
      //   let keysList = Object.keys(item)
      //   keysList.forEach((key, keyIndex) => {
      //     item[key] = `${(tempColum?.[keyIndex]?.children?.[3]?.value ?? '')}${item[key]}${(tempColum?.[keyIndex]?.children[4]?.value ?? '')}`
      //   })

      //   return item
      // })
      tempColum.forEach(itemTem => {
        list.forEach(listItem => {
          listItem[itemTem.children[1].value] = `${(itemTem?.children?.[3]?.value ?? '')}${listItem[itemTem.children[1].value]}${(itemTem?.children[4]?.value ?? '')}`
        })
      })

      return list
    },
    tableColumn () {
      let temp = this.config.tableColumn
      temp = temp.map((item, idx) => {
        return {
          id: idx + 1,
          label: item.children[0].value,
          prop: item.children[1].value,
          width: item.children[2].value
        }
      })
      return temp
    }
  }
}
</script>

<style lang="stylus">
.define-table-wrap
  padding 10px 0
  .defineTable
    .el-table--border, .el-table--group
      border 1px solid #241f3d
    .el-table--border::after, .el-table--group::after, .el-table::before
      background none
    .el-table th
      background-image linear-gradient(90deg,#005eff,#1896ff)
      color #ffffff
      text-align center
    .el-table tr
      background #1a1533
    .el-table td
      color #a5a5b4
    .el-table td, .el-table th.is-leaf
      border-bottom 1px solid #241f3d
    .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed
      border-right 1px solid #241f3d
    .el-table td, .el-table th
      padding 8px 0
    .el-table td, .el-table th.is-leaf
      border-bottom none
    .el-table::before
      background-color #191c21
    .el-table--enable-row-hover .el-table__body tr:hover>td
      background-color #1f1e44
    .el-table--striped .el-table__body tr.el-table__row--striped td
      background #1f1e44
    .el-table__empty-block
      background #201e44
    .el-table--scrollable-x .el-table__body-wrapper
      overflow-x hidden
    .el-table, .el-table__expanded-cell
      background none
    .el-table--scrollable-y .el-table__body-wrapper
      &::-webkit-scrollbar
        width: 0.75rem;
        height: 0.75rem;
        background-color: #F5F5F5;
      &::-webkit-scrollbar-track
        box-shadow: inset 0 0 0.375rem #999;
        border-radius: 0.625rem;
        background-color: #F5F5F5;
      &::-webkit-scrollbar-thumb
        border-radius: 0.625rem;
        box-shadow: inset 0 0 0.375rem #999;
        background-color: #333;
.define-table-wrap
  .defineTable.isSpaced
    .el-table th,td
      padding 0!important
    .el-table .cell
      line-height initial
</style>
